/* eslint-disable @typescript-eslint/camelcase */
import {
  HangingConfirmDonePosBkdPayload,
  HangingLastMileConfirmApiRequest,
  SubmitHangingConfirmationFollowUp,
  SubmitHangingConfirmationUpdateStatus
} from "@/data/payload/api/HangingApiRequest";
import { HangingIncomingMapper } from "@/data/persistences/mappers/HangingIncomingMapper";
import {
  HangingIncomingSummary,
  HangingIncomingFilterRequest,
  FilterRiwayatRequest,
  RiwayatHangingLasmileRequest,
  RiwayatHangingLasmileEntities,
  HangingIncoming,
  HistoryFollowUpIncomingRequest,
  HistoryFollowUpIncomingEntities,
  HistoryHangingIncomingFilterRequest,
  HistoryHangingIncomingEntities,
  HangingIncomingUpdateStatus,
  HistoryHanging
} from "@/domain/entities/HangingIncoming";
import { HangingLastMileMapper } from "@/data/persistences/mappers/HangingLastMileMapper";
import {
  HangingLastMile,
  HangingLastMileSummary,
  HistoryFollowUpLastMileEntities,
  HistoryFollowUpLastMileRequest
} from "@/domain/entities/HangingLastMile";
import { HangingRepositoryInterface } from "@/data/persistences/repositories/contracts/HangingRepositoryInterface";
import { HangingEndpoint } from "../../endpoints/HangingEndpoint";
import ApiService from "../../services/ApiService";
import downloadFile from "@/app/infrastructures/misc/common-library/DownloadFile";
import { Endpoints } from "../../misc/Endpoints";
import { getHubData } from "../../misc/Cookies";
import { HangingMapper } from "@/data/persistences/mappers/HangingMapper";
import { CardHangingShared } from "@/domain/entities/CardHangingShared";
import {
  HistoryHangingBookingFilterRequest,
  HistoryHangingBookingEntities,
  HistoryFollowUpBookingFilterRequest,
  HistoryFollowUpBookingEntities
} from "@/domain/entities/HangingBooking";
import {
  HistoryFollowUpOutgoingFilterRequest,
  HistoryFollowUpOutgoingEntities,
  HangingOutgoingRequest,
  ConfirmHangingOutgoingRequest,
  DownloadHangingOutgoing,
  HangingBookingPosSummary
} from "@/domain/entities/HangingOutgoing";
import {
  HangingList,
  HangingPosBkdListRequest
} from "@/domain/entities/Hanging";
import { HangingBkdSummaryConsole, HangingConsoleBkdListRequest, ConfirmHangingBkdConsole, DownloadHangingBkdConsole } from '@/domain/entities/HangingBkd';
export class HangingApiRepository implements HangingRepositoryInterface {
  private service: ApiService;
  private hangingIncomingMapper: HangingIncomingMapper;
  private hangingLastMileMapper: HangingLastMileMapper;
  private hangingMapper: HangingMapper;
  private endpoints: HangingEndpoint;

  constructor(
    service: ApiService,
    hangingIncomingMapper: HangingIncomingMapper,
    hangingLastMileMapper: HangingLastMileMapper,
    hangingMapper: HangingMapper,
    endpoints: HangingEndpoint
  ) {
    this.service = service;
    this.hangingIncomingMapper = hangingIncomingMapper;
    this.hangingLastMileMapper = hangingLastMileMapper;
    this.hangingMapper = hangingMapper;
    this.endpoints = endpoints;
  }

  public async getHangingIncomingSummary(): Promise<HangingIncomingSummary> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingIncomingSummary(),
      {}
    );
    return this.hangingIncomingMapper.convertHangingIncomingSummaryFromApi(
      resp
    );
  }

  public async getHangingLastMileSummary(): Promise<HangingLastMileSummary> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingLastMileSummary(),
      {}
    );
    return this.hangingLastMileMapper.convertHangingLastMileSummaryFromApi(
      resp
    );
  }

  public async getHangingIncoming(
    params: HangingIncomingFilterRequest
  ): Promise<HangingIncoming[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingIncoming(params),
      {}
    );
    return this.hangingIncomingMapper.convertHangingIncomingListFromApi(resp);
  }

  public async getHangingLastMile(
    params: HangingIncomingFilterRequest
  ): Promise<HangingLastMile[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingLastMile(params),
      {}
    );
    return this.hangingLastMileMapper.convertHangingLastMileListFromApi(resp);
  }

  public async getFilterRiwayat(
    params: FilterRiwayatRequest
  ): Promise<HangingIncomingSummary> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getFilterRiwayat(params),
      {}
    );
    return this.hangingIncomingMapper.convertHangingIncomingSummaryFromApi(
      resp
    );
  }
  public async submitHangingConfirmationFollowUp(
    payload: SubmitHangingConfirmationFollowUp
  ): Promise<void> {
    await this.service.invoke(
      "post",
      this.endpoints.submitHangingConfirmationFollowUp(),
      {},
      payload as SubmitHangingConfirmationFollowUp
    );
  }

  public async hangingLastMileConfirmFollowUp(
    payload: HangingLastMileConfirmApiRequest
  ): Promise<void> {
    await this.service.invoke(
      "post",
      this.endpoints.hangingLastMileConfirmFollowUp(),
      {},
      payload
    );
  }

  public async submitHangingConfirmationUpdateStatus(
    payload: SubmitHangingConfirmationUpdateStatus
  ): Promise<HangingIncomingUpdateStatus> {
    const resp = await this.service.invoke(
      "post",
      this.endpoints.submitHangingConfirmationUpdateStatus(),
      {},
      payload as SubmitHangingConfirmationUpdateStatus
    );
    return this.hangingIncomingMapper.convertHangingIncomingUpdateStatusResponse(
      resp
    );
  }
  public async getRiwayatHangingLastmile(
    params: RiwayatHangingLasmileRequest
  ): Promise<RiwayatHangingLasmileEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getRiwayatHangingLastmile(params),
      {}
    );
    return this.hangingIncomingMapper.convertHangingIncomingRiwayatLasymileFromApi(
      resp
    );
  }

  public async downloadHangingIncoming(listStt: []): Promise<void> {
    downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.donwloadHangingIncoming()}`,
      `hanging-incoming-data`,
      ".csv",
      true,
      undefined,
      "post",
      { stt_no: listStt, hub_id: getHubData()?.hubId || 0 },
      true
    );
  }

  public async downloadHangingLastMile(listStt: []): Promise<void> {
    downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.donwloadHangingLastMile()}`,
      `hanging-last-mile-data`,
      ".csv",
      true,
      undefined,
      "post",
      { stt_no: listStt, hub_id: getHubData()?.hubId || 0 },
      true
    );
  }

  public async getHistoryFollowUpIncoming(
    params: HistoryFollowUpIncomingRequest
  ): Promise<HistoryFollowUpIncomingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryFollowUpIncoming(params),
      {}
    );
    return this.hangingIncomingMapper.convertHistoryFollowUpIncomingFromApi(
      resp
    );
  }

  public async getHistoryFollowUpLastMile(
    params: HistoryFollowUpLastMileRequest
  ): Promise<HistoryFollowUpLastMileEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryFollowUpLastMile(params),
      {}
    );
    return this.hangingLastMileMapper.convertHistoryFollowUpLastMileFromApi(
      resp
    );
  }

  public async getHistoryHangingIncoming(
    params: HistoryHangingIncomingFilterRequest
  ): Promise<HistoryHangingIncomingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryHangingIncoming(params),
      {}
    );
    return this.hangingIncomingMapper.convertHistoryHangingIncomingListFromApi(
      resp
    );
  }

  public async getHangingOutgoingSummary() {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingOutgoingSummary()
    );

    return this.hangingMapper.convertHangingOutgoingSummaryFromApi(resp);
  }

  public async getHistoryHangingOutgoing(
    params: RiwayatHangingLasmileRequest
  ): Promise<HistoryHanging> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryHangingOutgoing(params),
      {}
    );
    return this.hangingMapper.convertHistoryHangingFromApi(resp);
  }

  public async getHistoryFollowUpOutgoing(
    params: HistoryFollowUpOutgoingFilterRequest
  ): Promise<HistoryFollowUpOutgoingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryFollowUpOutgoing(params),
      {}
    );
    return this.hangingIncomingMapper.convertHistoryFollowUpOutgoingFromApi(
      resp
    );
  }

  public async getHangingBookingPosSummary(): Promise<
    HangingBookingPosSummary
  > {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingBookingPosSummary()
    );

    return this.hangingMapper.convertHangingBookingPosSummaryFromApi(resp);
  }

  public async getHangingOutgoing(
    params: HangingOutgoingRequest
  ): Promise<CardHangingShared[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingOutgoing(params)
    );
    return this.hangingMapper.convertHangingOutgoingFromApi(resp);
  }

  public async confirmHangingOutgoing(
    payload: ConfirmHangingOutgoingRequest
  ): Promise<boolean> {
    await this.service.invoke(
      "post",
      this.endpoints.confirmHangingOutgoing(),
      undefined,
      payload
    );

    return true;
  }

  public async downloadHangingOutgoing(
    payload: DownloadHangingOutgoing
  ): Promise<void> {
    downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.donwloadHangingOutgoing()}`,
      `hanging-outgoing-data`,
      ".csv",
      true,
      undefined,
      "post",
      payload.toPayload(),
      true
    );
  }

  public async getHistoryHangingBooking(
    params: HistoryHangingBookingFilterRequest
  ): Promise<HistoryHangingBookingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryHangingBooking(params),
      {}
    );
    return this.hangingMapper.convertHistoryHangingBookingListFromApi(resp);
  }

  public async getHistoryFollowUpBooking(
    params: HistoryFollowUpBookingFilterRequest
  ): Promise<HistoryFollowUpBookingEntities> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHistoryFollowUpBooking(params),
      {}
    );
    return this.hangingMapper.convertHistoryFollowUpBookingFromApi(resp);
  }

  public async getHangingPosBkd(
    params: HangingPosBkdListRequest
  ): Promise<HangingList[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingPosBkd(params),
      {}
    );
    return this.hangingMapper.convertHangingListFromApi(resp);
  }

  public async donwloadHangingPosBkd(listStt: []): Promise<void> {
    downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.donwloadHangingPosBkd()}`,
      `hanging-booking`,
      ".csv",
      true,
      undefined,
      "post",
      { stt_no: listStt, hub_id: getHubData()?.hubId || 0 },
      true
    );
  }

  public async confirmDoneHangingPosBkd(
    payload: HangingConfirmDonePosBkdPayload
  ): Promise<void> {
    await this.service.invoke(
      "post",
      this.endpoints.confirmDoneHangingPosBkd(),
      {},
      payload
    );
  }

  public async getHangingConsoleBkdSummary(): Promise<HangingBkdSummaryConsole> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingBkdConsoleSummary(),
    )

    return this.hangingMapper.convertHangingBkdConsoleSummaryFromApi(resp);
  }

  public async getHangingConsoleBkdList(
    params: HangingConsoleBkdListRequest
  ): Promise<CardHangingShared[]> {
    const resp = await this.service.invoke(
      "get",
      this.endpoints.getHangingBkdConsoleList(params)
    )

    return this.hangingMapper.convertHangingBkdConsoleFromApi(resp);
  }

  public async confirmHangingBkdConsole(payload: ConfirmHangingBkdConsole): Promise<boolean> {
    await this.service.invoke(
      "post",
      this.endpoints.confirmDoneHangingPosBkd(),
      undefined,
      payload
    )

    return true
  }

  public async downloadHangingBkdConsole(payload: DownloadHangingBkdConsole): Promise<void> {
    downloadFile(
      `${Endpoints.baseUrl}${this.endpoints.donwloadHangingPosBkd()}`,
      `hanging-booking`,
      ".csv",
      true,
      undefined,
      "post",
      { stt_no: payload.listStt, hub_id: getHubData()?.hubId || 0 },
      true
    );
  }
}

